import { additionalStructureFeatureKeysToRender } from '../../../redux/features/selectors/commentarySelectors/selectAdditionalStructureCommentary.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { CommentarySubSection } from '../components/CommentarySubsection.tsx';
import { AdditionalStructure } from './AdditionalStructure.tsx';
import { structuresCommentarySubSectionProps } from './consts.ts';

export const AdditionalStructures = () => {
  const structureKeys = useAppSelector(additionalStructureFeatureKeysToRender);

  if (structureKeys.length === 0) {
    return null;
  }

  return (
    <CommentarySubSection {...structuresCommentarySubSectionProps}>
      {structureKeys.map((structureKey, index) => (
        <AdditionalStructure
          key={`additional-structure-${structureKey}-${index}`}
          structureKey={structureKey}
        />
      ))}
    </CommentarySubSection>
  );
};
